<template>
  <div>
    <b-modal id="modal-input" size="lg" centered :title="$store.state.modal.tambahAnnouncement" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <!-- 1. Title -->
        <b-form-group :label="$store.state.form.judul" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('judul')" v-model="$v.data.judul.$model" autofocus></b-form-input>
        </b-form-group>

        <!-- 2. Target -->
        <b-form-group :label="$store.state.form.target" label-cols-md="3">
          <b-form-select :options="targetOptions" v-model="$v.data.target.$model" :state="checkIfValid('target')"></b-form-select>
        </b-form-group>

        <!-- Divisi (only if target = 'division') -->
        <b-form-group v-if="data.target === 'division'" label="Divisi" label-cols-md="3">
          <div class="w-100">
            <Multiselect
              id="Divisi"
              v-model="$v.data.masterDivisiId.$model"
              :options="divisiOptions"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="-- Pilih Divisi --"
              label="namaDivisi"
              track-by="masterDivisiId"
              class="multiselect-bootstrap"
            />
          </div>
        </b-form-group>

        <!-- Posisi (only if target = 'position') -->
        <b-form-group v-if="data.target === 'position'" label="Posisi" label-cols-md="3">
          <div class="w-100">
            <Multiselect
              id="Posisi"
              v-model="$v.data.masterPosisiId.$model"
              :options="posisiOptions"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="-- Pilih Posisi --"
              label="namaPosisi"
              track-by="masterPosisiId"
              class="multiselect-bootstrap"
            />
          </div>
        </b-form-group>

        <!-- User (only if target = 'user') -->
        <b-form-group v-if="data.target === 'user'" label="User" label-cols-md="3">
          <div class="w-100">
            <Multiselect
              id="User"
              v-model="$v.data.masterUserId.$model"
              :options="userOptions"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="-- Pilih User --"
              label="namaKaryawan"
              track-by="masterUserId"
              class="multiselect-bootstrap"
            />
          </div>
        </b-form-group>

        <!-- 4. File Upload -->
        <b-form-group :label="$store.state.form.file" label-cols-md="3">
          <b-form-file v-model="data.file" :state="checkIfValid('file')" browse-text="Pilih File" placeholder="Pilih atau seret file ke sini..."></b-form-file>
        </b-form-group>

        <b-form-group :label="$store.state.form.pesan" label-cols-md="3">
          <b-form-textarea rows="3" max-rows="6" v-model="data.isi" placeholder="Masukkan Pesan"></b-form-textarea>
        </b-form-group>

        <!-- 5. Broadcast Date -->
        <!-- <b-form-group :label="$store.state.form.broadcastDate" label-cols-md="3">
          <b-form-datepicker v-model="$v.data.broadcastDate.$model" :state="checkIfValid('broadcastDate')" reset-button locale="id"></b-form-datepicker>
        </b-form-group> -->
      </b-form>
      <!-- Footer -->
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "modalInput",
  props: ["divisiOptions", "posisiOptions", "userOptions"],
  data() {
    return {
      data: {
        judul: "",
        target: "all",
        masterUserId: [],
        masterDivisiId: [],
        masterPosisiId: [],
        file: null,
        broadcastDate: null,
        tipe: "announcement",
        isi: "",
        all: false,
      },
      busy: false,
      button: "Simpan",
      targetOptions: [
        { value: "all", text: "All" },
        { value: "user", text: "User" },
        { value: "division", text: "Division" },
        { value: "position", text: "Position" },
      ],
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    isValid() {
      return !this.$v.data.$invalid;
    },
    list_divisi() {
      return this.data.masterDivisiId.map((d) => d.masterDivisiId);
    },
    list_posisi() {
      return this.data.masterPosisiId.map((p) => p.masterPosisiId);
    },
    list_user() {
      return this.data.masterUserId.map((u) => u.masterUserId);
    },
  },
  mixins: [validationMixin],
  validations() {
    return {
      data: {
        judul: { required },
        target: { required },
        masterDivisiId: {
          requiredIf: (val) => {
            return this.data.target !== "division" || (val && val.length > 0);
          },
        },
        masterPosisiId: {
          requiredIf: (val) => {
            return this.data.target !== "position" || (val && val.length > 0);
          },
        },
        masterUserId: {
          requiredIf: (val) => {
            return this.data.target !== "user" || (val && val.length > 0);
          },
        },

        file: { required },
        // broadcastDate: { required },
      },
    };
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) return null;
      return !field.$invalid;
    },

    simpan() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$bvToast.toast("Silakan lengkapi data terlebih dahulu", {
          title: "Validasi",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.busy = true;
      this.button = this.$store.state.form.tunggu;
      const formData = new FormData();
      formData.append("judul", this.data.judul);
      if (this.data.target === "division") {
        formData.append("masterDivisiId", this.list_divisi);
      } else if (this.data.target === "position") {
        formData.append("masterPosisiId", this.list_posisi);
      } else if (this.data.target === "user") {
        formData.append("masterUserId", this.list_user);
      }
      if (this.data.target == "all") {
        this.data.all = true;
      }
      formData.append("isi", this.data.isi || "");
      formData.append("all", this.data.all);
      formData.append("file1", this.data.file);
      formData.append("tipe", this.data.tipe);
      // formData.append("broadcastDate", this.data.broadcastDate);
      this.$axios
        .post("announcement/register", formData)
        .then((res) => {
          this.$emit("alertFromChild", {
            variant: res.data.message === "sukses" ? "success" : "danger",
            msg: res.data.message === "sukses" ? "BERHASIL MENDAFTARKAN ANNNOUNCEMENT" : res.data.message.toUpperCase(),
            showing: true,
          });
          this.resetForm();
          this.$bvModal.hide("modal-input");
        })
        .catch((err) => {
          this.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        })
        .finally(() => {
          this.busy = false;
          this.button = this.$store.state.form.simpan;
        });
    },
    resetForm() {
      this.data = {
        judul: "",
        target: "all",
        masterUserId: [],
        masterDivisiId: [],
        masterPosisiId: [],
        file: null,
        broadcastDate: null,
        tipe: "announcement",
        isi: "",
        all: false,
      };
      this.$v.$reset();
    },
  },
  watch: {
    lang() {
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>

<style scoped>
.multiselect-bootstrap {
  min-height: calc(1.5em + 0.75rem + 2px); /* match Bootstrap input */
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.multiselect-bootstrap .multiselect__tags {
  border: none;
  padding: 0.375rem 0.75rem;
  display: flex;
  align-items: center;
  min-height: auto;
}

.multiselect-bootstrap .multiselect__input,
.multiselect-bootstrap .multiselect__single {
  font-size: 0.875rem;
  margin: 0;
  padding: 0;
}

.multiselect-bootstrap .multiselect__placeholder {
  color: #6c757d; /* Bootstrap placeholder color */
}

.multiselect-bootstrap .multiselect__content-wrapper {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-top: 2px;
  z-index: 2000; /* above modal */
}

.multiselect-bootstrap .multiselect__option--highlight {
  background: #007bff;
  color: #fff;
}
</style>
